import { Badge, Body1, BrandGraphic, Card, TextSpan, Title5, XStack, YStack } from "@medbillai/ui";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import { StatCard } from "../../components/StatCard";
import { type OnDone, tagged } from "../../lib/flow-engine";
export type BillEducationOutcomes = {
  continue: {};
  back: {};
};
const Outcome = tagged<BillEducationOutcomes>();
const STATS = [{
  value: "8 in 10",
  label: "medical bills contain errors"
}, {
  value: "93%",
  label: "of patients never dispute a charge"
}] as const;

/** Static bill-branch interstitial; no persistence. */
export function BillEducation({
  onDone
}: {
  onDone: OnDone<BillEducationOutcomes>;
}) {
  return <OnboardingScreen data-sentry-element="OnboardingScreen" data-sentry-component="BillEducation" data-sentry-source-file="BillEducation.tsx">
      <OnboardingScreen.Nav onBackPress={() => onDone(Outcome.back())} showLogo={false} data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="BillEducation.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="BillEducation.tsx">
        <OnboardingScreen.Header alignment="left" title="Feeling overcharged? You're not alone" subtitle="Errors and overcharges are more common than you'd think." data-sentry-element="OnboardingScreen.Header" data-sentry-source-file="BillEducation.tsx" />
        <YStack gap="$sp2" data-sentry-element="YStack" data-sentry-source-file="BillEducation.tsx">
          <XStack gap="$sp2" data-sentry-element="XStack" data-sentry-source-file="BillEducation.tsx">
            {STATS.map(stat => <StatCard key={stat.value} headline={stat.value} body={stat.label} />)}
          </XStack>
          <Card variant="elevated" size="large" data-sentry-element="Card" data-sentry-source-file="BillEducation.tsx">
            <YStack gap="$sp1.5" data-sentry-element="YStack" data-sentry-source-file="BillEducation.tsx">
              <XStack justifyContent="space-between" alignItems="flex-start" gap="$sp2" data-sentry-element="XStack" data-sentry-source-file="BillEducation.tsx">
                <YStack gap="$sp1" alignItems="flex-start" flexShrink={1} data-sentry-element="YStack" data-sentry-source-file="BillEducation.tsx">
                  <Badge status="positive" size="small" data-sentry-element="Badge" data-sentry-source-file="BillEducation.tsx">
                    The Granted Difference
                  </Badge>
                  <Title5 data-sentry-element="Title5" data-sentry-source-file="BillEducation.tsx">Members save $840 on average</Title5>
                </YStack>
                <BrandGraphic type="bill" indicator="dollar" size="$si7" data-sentry-element="BrandGraphic" data-sentry-source-file="BillEducation.tsx" />
              </XStack>
              <Body1 color="$textSubtle" data-sentry-element="Body1" data-sentry-source-file="BillEducation.tsx">
                We review every line of your bill, catch mistakes and negotiate
                it down{" "}
                {/* `unstyled` keeps the span on the parent's $textSubtle —
                    TextSpan otherwise applies the default text color. */}
                <TextSpan bold unstyled data-sentry-element="TextSpan" data-sentry-source-file="BillEducation.tsx">
                  for a small cut of the savings.
                </TextSpan>
              </Body1>
            </YStack>
          </Card>
        </YStack>
      </OnboardingScreen.Content>
      <OnboardingScreen.Footer data-sentry-element="OnboardingScreen.Footer" data-sentry-source-file="BillEducation.tsx">
        <OnboardingScreen.PrimaryAction testID="feeling-overcharged.continue" variant="brand" onPress={() => onDone(Outcome.continue())} data-sentry-element="OnboardingScreen.PrimaryAction" data-sentry-source-file="BillEducation.tsx">
          Continue
        </OnboardingScreen.PrimaryAction>
      </OnboardingScreen.Footer>
    </OnboardingScreen>;
}